
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';

export const example = defineCommand(
    'assistant',
    'assistant...',
    (r) => {
        // Do something...
    }
);

export const inAssistantCommands = () => inCommands(
    example,
);

